/**
 * Scheduler Amplitude: event name strings.
 */

export const SCHEDULER_AMPLITUDE_EVENTS = {
  TEMPLATE: {
    COPY_LINK_CLICKED: 'Copy Link Clicked',
    TEAM_TEMPLATES_PAGE_VISITED: 'Team Templates Page Visited',
    TEMPLATE_CREATED: 'Template Created',
    TEMPLATE_CREATION_CANCELLED: 'Template Creation Cancelled',
    TEMPLATE_DELETED: 'Template Deleted',
    TEMPLATE_UPDATED: 'Template Updated',
    TEMPLATES_PAGE_VISITED: 'Templates Page Visited',
  },
} as const;
